import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  TextField,
  Box,
  Typography,
  Divider,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { AddButton } from '../../button/button';

interface AllocateModalProps {
  open: boolean;
  onClose: () => void;
  onAllocate: (maxTask: number) => void;
  maxTask: string;
  setMaxTask: (value: string) => void;
}

const AllocateModal: React.FC<AllocateModalProps> = ({
  open,
  onClose,
  onAllocate,
  maxTask,
  setMaxTask,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ p: 2 }}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6" fontWeight="bold">
            Max Task Per Expert
          </Typography>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>

      <Divider />

      <DialogContent sx={{ p: 3 }}>
        <TextField
          type="number"
          label="Max Task Per Expert"
          value={maxTask}
          onChange={(e) => setMaxTask(e.target.value)}
          fullWidth
          size="small"
          variant="outlined"
        />
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <AddButton
          variant="contained"
          onClick={() => onAllocate(Number(maxTask))}
          disabled={!maxTask}
          fullWidth
        >
          Allocate
        </AddButton>
      </DialogActions>
    </Dialog>
  );
};

export default AllocateModal;
